import React from 'react'
import moment from 'moment';

import { getSystemSettings, getUserSettings, getCurrencyDatabase } from '../../utils/SettingsRetriever';
import IntlMessage from '../../LocaleEngine';

import './index.scss';


export default class Currency extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hash: moment().unix(),
            currencySettings: getSystemSettings().app.currency,
            selectedCurrencyIndex: getUserSettings().currencies.selected
        }
    }

    convertCurrency = (ammount, destination) => {
        const CurrencyDB = getCurrencyDatabase();
        if (CurrencyDB) return (ammount * CurrencyDB.rates[destination]).toFixed(2);
        else return ammount;
    }
    
    triggerUpdate = () => {
        this.setState({
            ...this.state, 
            hash: moment().unix(),
            currencySettings: getSystemSettings().app.currency,
            selectedCurrencyIndex: getUserSettings().currencies.selected
        });
    }

    render() {

        let decimalFontSize = "50%"
        if (getSystemSettings() 
            && getSystemSettings().app 
            && getSystemSettings().app.currency 
            && getSystemSettings().app.currency.decimalFontSize ){
            decimalFontSize = getSystemSettings().app.currency.decimalFontSize
        }

        document.addEventListener("changeCurrency", this.triggerUpdate);
        
        const currencyIndex = this.state.currencySettings.default;
        const currency
            = (this.state.currencySettings.displayMethod === "full" ? this.state.currencySettings.list[currencyIndex].base : "")
            + " " + this.state.currencySettings.list[currencyIndex].symbol;

        let { value = 0 } = this.props;
        value = parseFloat(value);
        let convertedValue = this.convertCurrency(value, this.state.currencySettings.list[this.state.selectedCurrencyIndex].base);

        if (this.props.loadingSearch) {
            return (
                <React.Fragment>
                    <div className="priceWrap">
                        <span className="price free"><IntlMessage id="header.lodging.form.searching" /></span>
                    </div>
                </React.Fragment>
            );
        }

        if (value === 0 && this.props.make) {
            return (
                <React.Fragment>
                    <div className="priceWrap">
                        <span className="price free"><IntlMessage id="currency.labels.sold_out" /></span>
                    </div>
                </React.Fragment>
            );
        }

        if (value === 0 && !this.props.taxes && this.state.currencySettings.showFree !== false && !this.props.noFree) {
            return (
                <React.Fragment>
                    <div className="priceWrap">
                        <span className="price free"><IntlMessage id="cart.labels.free" /></span>
                    </div>
                </React.Fragment>
            );
        }

        else {
            value = (
                <React.Fragment>
                    <span>{value.toFixed(2).split('.')[0]}</span><span className="decimal" style={{ fontSize: decimalFontSize }}>.{value.toFixed(2).split('.')[1]}</span>
                </React.Fragment>
            )
        }

        let generalClass = 'priceWrap';
        if(this.props.displayType === 1) generalClass += ' final';
        if(this.props.displayType === 2) generalClass += ' original';

        return (
            <React.Fragment>
                <div className={generalClass}>
                    <span className="currency">{currency}</span>
                    <span className={(this.props.strikeThrough ? "price strikeThrough " : "" ) + "price"}>{value}</span>
                    {
                        (this.state.currencySettings.default !== this.state.selectedCurrencyIndex && value !== 0 && !this.props.onlyOriginal) && (
                            <div className="converted">
                                <span className="currency converted">
                                    {this.state.currencySettings.list[this.state.selectedCurrencyIndex].base}
                                </span>
                                <span className="price converted">
                                    <React.Fragment><span>{convertedValue.split('.')[0]}</span><span style={{ fontSize: decimalFontSize }}>.{convertedValue.split('.')[1]}</span> </React.Fragment>
                                </span>
                            </div>
                        )
                    }
                </div>
            </React.Fragment>
        );
    }

};
